import React, { useEffect, useRef } from 'react';
import PrivacyPolicy, { PrivacyPolicyText } from '../../../../../components/PrivacyPolicy';
import { isMobileOidc } from '../../../../../utilities/oidc/oidc';
import { useRegisterComponent } from '../../../../orchestrator';
import { WELCOME_PAGE_ID } from '../../constants';
import { useWelcomePageContext } from '../../contexts';
import { RootState, useAppSelector } from '../../../../../stores/redux.store';
import { useWelcomeState } from '../../hooks';

const isEmbeddedSelectorFn = (state: RootState) => Boolean(state.microbranding.isEmbedded);

export const WelcomePrivacyPolicy = () => {
  useRegisterComponent(WelcomePrivacyPolicy.name);

  const privacyPolicyMessageRef = useRef<HTMLParagraphElement>(null);

  const { state: { oidcContext } = {} } = useWelcomeState();
  const isEmbedded = useAppSelector(isEmbeddedSelectorFn);

  const { setPrivacyPolicyText } = useWelcomePageContext();

  const privacyPolicyText = privacyPolicyMessageRef.current?.innerHTML || '';

  useEffect(() => {
    if (privacyPolicyText) {
      setPrivacyPolicyText(privacyPolicyText);
    }
  }, [privacyPolicyText, setPrivacyPolicyText]);

  return (
    <PrivacyPolicy
      isEmbedded={isEmbedded}
      isMobileOidc={isMobileOidc(oidcContext)}
      pageId={WELCOME_PAGE_ID}
      privacyPolicyText={PrivacyPolicyText.passwordSignup}
      ref={privacyPolicyMessageRef}
    />
  );
};
